import { CustomReportFilters } from '@/hooks'
import deepEqual from 'fast-deep-equal'

// @todo add test where
// { nodeIds: [1], commodityTypeIds: undefined } is equal to { nodeIds: [1] }
export const haveFiltersChanged = (
    a: CustomReportFilters,
    b: CustomReportFilters
) => {
    const cleanA = cleanUpFilters(a)
    const cleanB = cleanUpFilters(b)

    return !deepEqual(cleanA, cleanB)
}

const cleanUpFilters = (obj: Record<string, unknown>) => {
    return Object.fromEntries(
        Object.entries(obj)
            // remove undefined values
            .filter(([_, v]) => v !== undefined)
            // sort array values
            .map(([k, v]) => [k, Array.isArray(v) ? v.slice().sort() : v])
    )
}

// @todo add test where
// ['date', 'usage'] should be equal to ['usage']
// ['cost', 'usage'] should be equal to ['usage', 'cost']
export const haveDatasetsChanged = (a: string[], b: string[]) => {
    const cleanA = removeDateDataset(a)
    const cleanB = removeDateDataset(b)

    return (
        !cleanA.every((itemA) => cleanB.includes(itemA)) ||
        !cleanB.every((itemB) => cleanA.includes(itemB))
    )
}

const removeDateDataset = (datasets: Array<string>) => {
    return datasets.filter((dataset) => dataset !== 'date').sort()
}

export const hasNameChanged = (a: string, b: string) => {
    return a.trim().toLowerCase() !== b.trim().toLowerCase()
}

const cleanUpSettings = <T extends Record<string, unknown>>(obj: T): T => {
    const result = {} as T
    for (const [k, v] of Object.entries(obj)) {
        if (v === undefined) continue
        result[k as keyof T] = Array.isArray(v)
            ? ([...(v as unknown[])].sort() as unknown as T[keyof T])
            : (v as T[keyof T])
    }
    return result
}

export const haveSettingsChanged = (
    a: Record<string, unknown>,
    b: Record<string, unknown>
): boolean => {
    const cleanA = cleanUpSettings(a)
    const cleanB = cleanUpSettings(b)
    return !deepEqual(cleanA, cleanB)
}
